

export const frontMatter = {
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/numbers_1-10.html',
	description: 'Explore the numbers 1-10 across various Slavic languages, including natural, constructed, and fictional dialects, for a comprehensive linguistic comparison.',
	tags: [
		'interslavic',
		'numbers',
		'grammar',
		'language learning',
		'linguistics',
		'comparative',
		'old church slavonic',
		'old novgorodian',
		'hutsul',
		'lemko-rusyn',
		'polabian',
		'kashubian',
		'podlachian'
	]
};
export const contentTitle = 'The Numbers 1-10 in Slavic Languages';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-learn-misc-numbers-1-10-md-89a.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, MDNumbers1} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!MDNumbers1) _missingMdxReference("MDNumbers1", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "the-numbers-1-10-in-slavic-languages",
        children: "The Numbers 1-10 in Slavic Languages"
      })
    }), "\n", _jsx(MDNumbers1, {}), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

